import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button  } from 'antd';
import { store } from 'Store/store.index';
import { PWA_INSTALL_STATUS, SDK_FINISH_INIT } from 'Constants/app.constant';
import {
  INSTALL_BUTTON_PWA_INSTALL,
  TOOLS_GA_EVENT_LABEL } from 'Components/viewer/ui/constants/tools.constants';

import intl from 'react-intl-universal';

import './PluginInstall.scss'
import { isQQ } from '@/utils/browser-info';

@inject('appStore', "userStore")
@observer
class PluginInstallDlg extends Component {
  constructor() {
    super()
    this.state = {
        value:2,
        isInitUI: false,
        isShowPwaDlg: false
    }

  }
  componentDidMount() {
    store.appStore.addAppEventListener(SDK_FINISH_INIT, this.onFinishLoadUI);
  }
  componentWillUnmount() {
    store.appStore.removeAppEventListener(SDK_FINISH_INIT, this.onFinishLoadUI);
  }
  onClickInstal=()=> {
    store.userStore.doSendGAEvent({
      eventKey: INSTALL_BUTTON_PWA_INSTALL,
      label: TOOLS_GA_EVENT_LABEL
    })
    store.appStore.setShowPluginInstall(false);
    store.appStore.doInstallPWAs();
  }
  onFinishLoadUI=()=> {
    this.setState({
      isInitUI: true
    });
  }
  downloadCloud=()=>{
    store.appStore.downloadEditorCloudApplication();
  }
  onClose=()=>{
    store.appStore.setShowPluginInstall(false)
  }
  onChange=(e)=>{
    this.setState({
      value: e.target.value,
    });
  }

  closePwaDlg=()=>{
    this.setState({
      isShowPwaDlg:false
    })
  }
  render() {
    const { isInitUI } = this.state;
    const { beforeInstallPWAsEvent, PWAsInstallStatus,isShowPluginInstall } = store.appStore;
    const isShowPWA = isInitUI && beforeInstallPWAsEvent && PWAsInstallStatus !== PWA_INSTALL_STATUS.cancel && isQQ === false;
    return (
      <>
          <Modal
            mask={false}
            centered={false}
            visible={isShowPluginInstall}
            className='common-dialog ant-alert-modal PluginInstallDlg'
            title={intl.get('HeaderContainer.PluginInstallDlg.title')}
            onCancel={this.onClose}
            footer={null}>
            <div className='wrapInstallOptions'>
              <div /* disabled={!isShowPWA} */ hidden={!isShowPWA}>
                <i className="installPwa"></i><span className={'dec'}>{intl.get('HeaderContainer.PluginInstallDlg.onlinePWA')}</span><Button onClick={this.onClickInstal} disabled={!isShowPWA}>{intl.get('HeaderContainer.InstallApp')}</Button>
              </div>
              <div className='onlineExeWrap'>
                <i className="installClound"></i>
                <div className='onlineExe-content'>
                  <span className={'dec'}>{intl.get('HeaderContainer.PluginInstallDlg.onlineExe')}</span>
                  <span className={'tip'}>{intl.get('HeaderContainer.PluginInstallDlg.onlineExeTip')}</span>
                </div>
                <Button onClick={this.downloadCloud} >{intl.get('HeaderContainer.DownloadApp')}</Button>
              </div>
           
            </div>
          </Modal>
      </>
       
    )
  }
}

export default PluginInstallDlg;